import { Button } from "@albelli/arc-3-react/lib/Button/Button";
import { ButtonGroup } from "@albelli/arc-3-react/lib/ButtonGroup/ButtonGroup";
import { ErrorBoundary } from "components/common/ErrorBoundary/ErrorBoundary";
import { Footer } from "components/common/Footer/Footer";
import { Header } from "components/common/Menu/Menu";
import { NavButton } from "components/common/NavButton/NavButton";
import { useLocalisedDocumentTitle } from "components/_hooks/useLocalisedDocumentTitle";
import React from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import styles from "./ChangeEmailSuccess.module.css";

export const ChangeEmailSuccess = () => {
  useLocalisedDocumentTitle();
  const mainLink = useSelector(state => state.menu.items.routes.Main);
  return (
    <ErrorBoundary>
      <Header />
      <div className={`arc3-container ${styles.container}`} data-cy="ChangeEmailSuccessPage">
        <div className="arc3-padding--left-lg arc3-padding--right-lg">
          <h1>
            <FormattedMessage id="changeEmailSuccess.title" defaultMessage="Your e-mail address has been changed!" />
          </h1>
          <p className="arc3-padding--bottom-lg">
            <FormattedMessage
              id="changeEmailSuccess.message"
              defaultMessage="Your e-mail address has been successfully changed. You can now continue to make fantastic photo products with your new email address!"
            />
          </p>
          <ButtonGroup className="arc3-full-width">
            <NavButton href="/" secondary>
              <FormattedMessage
                id="changeEmailSuccess.toMyAccountButton"
                defaultMessage="Login with your new email address"
              />
            </NavButton>
            <Button href={mainLink} data-cy="GoToStoreFrontButton">
              <FormattedMessage id="personalDetails.continueButton" defaultMessage="Continue" />
            </Button>
          </ButtonGroup>
        </div>
      </div>
      <Footer />
    </ErrorBoundary>
  );
};

export default ChangeEmailSuccess;
